import { IEditorV3 } from "@azu-business/editor-v3";
import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { CommentReadDto } from "./interface";

export interface CommentCreateDto {
  content: IEditorV3;
  parentId?: string;
  relatedTo?: string;
}
export interface AddHierarchyCommentDetails extends CommentCreateDto {
  hierarchyId: string;
}
export interface AddTlfItemCommentDetails extends CommentCreateDto {
  id: string;
  azsolId: string;
  version: number;
}
export type ICommentReturn = IAxiosReturn<CommentReadDto>;

/**
 * Add a comment to a hierarchy or TLF item.
 *
 * @param backEndUrl - Base backend URL
 * @param details - Details for the comment (hierarchy or TLF item)
 * @param controller - AbortController to cancel the request
 * @returns The created comment wrapped in ICommentReturn
 */
export const addComment = async (
  backEndUrl: string,
  details: AddHierarchyCommentDetails | AddTlfItemCommentDetails,
  controller: AbortController,
): Promise<ICommentReturn> => {
  try {
    if ((details as AddHierarchyCommentDetails).hierarchyId) {
      const hdets = details as AddHierarchyCommentDetails;
      const url = `${backEndUrl}Hierarchy/${hdets.hierarchyId}/Comments`;
      const ret = await axios.post(
        url,
        {
          content: details.content,
          parentId: details.parentId,
          relatedTo: details.relatedTo,
        },
        { signal: controller.signal },
      );
      return { success: true, data: ret.data };
    } else {
      const tdets = details as AddTlfItemCommentDetails;
      const url = `${backEndUrl}TlfItems/${tdets.id}/Comments`;
      const ret = await axios.post(
        url,
        {
          content: details.content,
          parentId: details.parentId,
          relatedTo: details.relatedTo,
        },
        { signal: controller.signal },
      );
      return { success: true, data: ret.data };
    }
  } catch (error) {
    return processAxiosError("Add comment failed", error);
  }
};
